import { Ng1StateDeclaration, StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../../application/UserProfile";
import { Machine } from "../../models/machine";

export const vsServiceName = "machineDetailTabsService";

export class MachineDetailTabsService {
  static basePath = "main.machines.detail";

  constructor(
    private readonly userProfile: UserProfile,
    private readonly tabs: ITabConfig[],
    private readonly $state: StateService
  ) {}

  static getSref(tab: ITabStateConfig): string {
    return `${MachineDetailTabsService.basePath}.${tab.uiSrefFragment}`;
  }

  getTabs(): ITabConfig[] {
    return this.tabs.filter(
      (t) =>
        !t.requiredPermission ||
        this.userProfile.hasPermission(t.requiredPermission)
    );
  }

  async navigateToTab(
    machineId: number,
    index: number = 0,
    reload: boolean = false
  ): Promise<void> {
    if (this.getTabs().length === 0) return;

    const tab = this.getTab(index);
    const uiSref = MachineDetailTabsService.getSref(tab);
    await this.$state.go(uiSref, { machineId }, { reload });
  }

  private getTab(index: number) {
    const tabs = this.getTabs();
    index = Math.min(Math.max(0, index), tabs.length - 1);
    return tabs[index];
  }

  getTabSref(index: number = 0) {
    const tab = this.getTab(index);
    return MachineDetailTabsService.getSref(tab);
  }
}
export interface ITabConfig extends ITabStateConfig {
  id: string;
  displayName: string;
  requiredPermission?: string;
}

export interface ITabStateConfig {
  uiSrefFragment: string;
  stateDefinition: Ng1StateDeclaration;
  children?: ITabStateConfig[];
}
